import {Row, Col} from 'antd';
import React, { useCallback, useState } from 'react';
import moment, {Moment} from 'moment';

// Components
import TitleComponent from '../../subComponents/TitleComponent';
import ButtonComponent from '../../subComponents/ButtonComponent';
import CalendarComponent from "./Calendar";
import DownloadCalendarModal from './DownloadCalendarModal';
import { CarryOutOutlined, TeamOutlined } from '@ant-design/icons';

const Planning = () => {
  const [resourcesModalVisible, setResourcesModalVisible] = useState(false);
  const [dateModalVisible, setDateModalVisible] = useState(false);
  const [visibleRange, setVisibleRange] = useState<[Moment, Moment]>([
    moment().startOf('month'),
    moment().endOf('month'),
  ]);

  const handleVisibleRangeChange = useCallback((startDate: Moment, endDate: Moment) => {
    setVisibleRange([startDate, endDate]);
  }, []);

  return (
    <Row>
      <Col md={14} sm={14} xs={24}>
        <TitleComponent level={3}
                        text={'Planeación'}
                        className={'font-semibold text-gray-900'} />
      </Col>
      <Col md={10} sm={10} xs={24} className='text-right'>
        <ButtonComponent
          icon={<CarryOutOutlined />}
          text='Descargar calendario'
          className={'w-fit text-white bg-blue-dkt-400 hover:bg-blue-dkt-500 focus:outline-none focus:ring-2 ' +
                        'focus:ring-offset-2 focus:ring-blue-dkt-300 after:content-none'}
          onClick={() => setDateModalVisible(true)}
        />
        <ButtonComponent
          icon={<TeamOutlined />}
          text='Editar recursos'
          className={'w-fit text-white bg-blue-dkt-400 hover:bg-blue-dkt-500 focus:outline-none focus:ring-2 ' +
                        'focus:ring-offset-2 focus:ring-blue-dkt-300 after:content-none'}
          onClick={() => setResourcesModalVisible(true)}
        />
      </Col>

      <Col md={24} xs={24} className={'mt-5 p-6 border border-grey-dkt-300 rounded-lg overflow-hidden bg-white'}>
        <CalendarComponent
          resourcesModalVisible={resourcesModalVisible}
          setResourcesModalVisible={setResourcesModalVisible}
          onVisibleRangeChange={handleVisibleRangeChange}
        />
      </Col>


      {dateModalVisible &&
        <DownloadCalendarModal
          onToggleModal={setDateModalVisible}
          visibleRange={visibleRange}
        />
      }
    </Row>
  );
}

export default Planning;